import React from "react";
import { LogoRound } from "../../common/ui/Logo";
import { TextBlock } from "../../common/ui/Text";
import { textCase } from "../../../service/ui/UI";

const TeamListItem = (props: {
  logo: string;
  name: string;
  title?: string;
  subTitle?: string;
}) => {
  return (
    <div className="d-flex align-items-center">
      <LogoRound url={props.logo} isProfile={true} name={props.name} />
      <div className="ps-4">
        <TextBlock
          maxLine={1}
          fontSize="17_18"
          fontName="medium"
          textColor="theme-label"
        >
          {textCase(props.name)}
        </TextBlock>

        {props.title !== undefined && (
          <TextBlock
            maxLine={1}
            fontSize="14_15"
            fontName="book"
            textColor="theme-sublabel"
          >
            {textCase(props.title)}
          </TextBlock>
        )}

        {props.subTitle !== undefined && (
          <TextBlock
            maxLine={1}
            fontSize="13_14"
            fontName="book"
            textColor="theme-sublabel"
          >
            {textCase(props.subTitle)}
          </TextBlock>
        )}
      </div>
    </div>
  );
};

export default TeamListItem;
